export default "__VITE_ASSET__DccPIvlM__"